import { axiosClient, getCSRFToken } from 'www/utils'

function getLpuSchedule({ url, addressId }) {
  return axiosClient({
    method: 'GET',
    url,
    params: {
      address: addressId,
    },
    headers: {
      'X-CSRFToken': getCSRFToken(),
      'Content-Type': 'application/json',
    },
  })
}

export default getLpuSchedule
